import { MenuItem, Select } from "@mui/material";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorInputProgress = (props: any, removeCancelled?: boolean) => {
  const { item, applyValue } = props;
  const handleChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };
  return (
    <Select
        sx={{maxWidth: '210px', width: '100%', justifyContent: 'center'}}
        labelId="progress-select-label"
        id="progress-select"
        value={item.value || ''}
        label="Status"
        onChange={handleChange}
        fullWidth
    >
        <MenuItem value={'upcoming'}>Upcoming</MenuItem>
        <MenuItem value={'in-progress'}>In Progress</MenuItem>
        <MenuItem value={'on-hold'}>On Hold</MenuItem>
          {!removeCancelled && <MenuItem value={'cancelled'}>Cancelled</MenuItem>}
        <MenuItem value={'completed'}>Completed</MenuItem>
    </Select>
  );
};

const StatusFilterOperator: GridFilterOperator[] = [
  {
      label: 'Is',
      value: 'eq',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (!cellValue || !filterValue) return false;

          const normalizedCellValue = cellValue.toString().toLowerCase().replace(/\s+/g, '-');
          const normalizedFilterValue = filterValue.toString().toLowerCase();
          return normalizedCellValue === normalizedFilterValue;
      }),
      InputComponentProps: { type: 'text' },
      InputComponent: (props: any) => CustomFilterOperatorInputProgress(props, false),
  }
];

export const StatusFilterOperatorWithoutCancelled: GridFilterOperator[] = 
StatusFilterOperator.map(x => {return {...x, InputComponent: (props: any) => CustomFilterOperatorInputProgress(props, true)}});
  
export default StatusFilterOperator;